import describeArc from "@/domains/targetMenu/helpers/describeArc";

const describeSector = ({ x, y, r, r2, startAngle, gap, endAngle }) => {
  const rStartAngle = startAngle + gap;
  const rEndAngle = endAngle - gap;
  const r2StartAngle = startAngle + gap * (r / r2);
  const r2EndAngle = endAngle - gap * (r / r2);

  return `${describeArc(x, y, r, rStartAngle, rEndAngle, false)} ${describeArc(x, y, r2, r2EndAngle, r2StartAngle, true)}Z`;
};

export default describeSector;
